import { getPlatform } from "../helpers";

const appBaseUrl = getPlatform();

export const pathConstants = {
  // AUTH PATH
  SIGNUP: "/signup",
  SIGNUP_INVITE: "/signup/team-invite",
  LOGIN: "/login",
  LOGIN_VERIFICATION: "/login/otp-verification",
  FORGOT_PASSOWRD: "/forgot-password",
  EMAIL_VERIFICATION: "/email-verification",
  RESET_PASSWORD: "/reset-password",
  SELLMODE_AUTH: "/cashier-login/access-code-verification",

  // Public pages
  SUBSCRIPTION_PLAN: "/subscription-plans",
  MENU: ({ id, path = "" }) => {
    return `/storefront/${id}${path}`;
  },
  MENU_ORDER_STATUS: "/order-status/:id",
  PLATFORM_NAVIGATOR: "/platform-navigator",

  // app path
  DASHBOARD_MAIN: appBaseUrl + "/dashboard",
  DASHBOARD_OVERVIEW: appBaseUrl + "/payments/overview/general",

  // accounting
  CHART_OF_ACCOUNTS: appBaseUrl + "/accountings/chart-of-accounts",
  ACCOUNTING_CHART_ACCOUNT_DETAILS: ({ account_id }) => {
    return appBaseUrl + `/accountings/chart-of-accounts/${account_id}`;
  },
  ACCOUNTING_CHART_ACCOUNT_TRANSACTION_DETAILS: ({ id }) => {
    return appBaseUrl + `/accountings/chart-of-accounts/transactions/${id}`;
  },

  ACCOUNT_SETTINGS: appBaseUrl + "/accountings/settings",
  ACCOUNTING_JOURNAL_ENTRIES: appBaseUrl + "/accountings/journal-entries",
  ACCOUNTING_CREATE_JOURNAL_ENTRY:
    appBaseUrl + "/accountings/journal-entries/create-journal-entry",
  ACCOUNTING_EDIT_JOURNAL_ENTRY: ({ reference }) => {
    return (
      appBaseUrl +
      `/accountings/journal-entries/edit-journal-entry/${reference}`
    );
  },
  ACCOUNTING_JOURNAL_ENTRY_DETAILS: ({ reference }) => {
    return appBaseUrl + `/accountings/journal-entries/${reference}`;
  },
  ACCOUNTING_GENERAL_LEDGER: appBaseUrl + "/accountings/general-ledger",
  ACCOUNTING_REPORTS: appBaseUrl + "/accountings/reports",
  REBATES_ACCOUNTINGS: appBaseUrl + "/accountings/rebates/transation",
  // end of accounting

  DASHBOARD_CASHFLOW_ANALYTICS:
    appBaseUrl + "/payments/overview/cashflow-analytics",
  DASHBOARD_CUSTOMER_ANALYTICS:
    appBaseUrl + "/payments/overview/customer-analytics",
  DASHBOARD_CONSENT_TO_SUPPLIERS:
    appBaseUrl + "/dashboard/consent-to-suppliers",

  PAYMENT_TRANSFER: appBaseUrl + "/payments/transfers",
  PAYMENT_TRANSFER_DETAILS: ({ transferId }) => {
    return appBaseUrl + `/payments/transfers/${transferId}`;
  },
  PAYMENT_TRANSFER_APPROVED: appBaseUrl + "/payments/transfers/approved",
  PAYMENT_TRANSFER_PENDING: appBaseUrl + "/payments/transfers/pending",
  PAYMENT_TRANSFER_REJECTED: appBaseUrl + "/payments/transfers/rejected",
  PAYMENT_TRANSFER_SAVEDBENEFICIARY:
    appBaseUrl + "/payments/transfers/beneficiaries",

  PAYMENT_TRANSACTIONS_ALL: appBaseUrl + "/payments/transactions",
  PAYMENT_TRANSACTIONS_DETAILS: ({ id }) => {
    return appBaseUrl + `/payments/transactions/${id}`;
  },

  PAYMENT_SUBACCOUNTS: appBaseUrl + "/payments/sub-accounts",
  PAYMENT_SUBACCOUNTS_CREATE: appBaseUrl + "/payments/sub-accounts/create",

  PAYMENT_POS_ALL_TERMINALS: appBaseUrl + "/payments/pos/all",
  PAYMENT_POS_TERMINAL_DETAILS: ({ terminalId }) => {
    return appBaseUrl + `/payments/pos/${terminalId}`;
  },
  PAYMENT_POS_TERMINAL_CREDENTIALS: ({ terminalId }) => {
    return appBaseUrl + `/payments/pos/${terminalId}/credentials`;
  },
  PAYMENT_POS_REQUEST_TERMINAL: appBaseUrl + "/payments/pos/request",
  PAYMENT_POS_ADD_TERMINALS: appBaseUrl + "/payments/pos/add",
  PAYMENT_ALL_TAGS: appBaseUrl + "/payments/tags",

  INVENTORY: appBaseUrl + "/inventory",
  INVENTORY_ANALYTICS: appBaseUrl + "/inventory/analytics",
  INVENTORY_PRODUCTS: appBaseUrl + "/inventory/products",
  INVENTORY_SERVICES: appBaseUrl + "/inventory/services",
  INVENTORY_COMPOSITE_PRODUCTS: appBaseUrl + "/inventory/composite-products",
  INVENTORY_PRODUCTS_ADD_SINGLE: appBaseUrl + "/inventory/products/add/single",
  INVENTORY_SERVICE_CREATE: appBaseUrl + "/inventory/services/add/single",
  INVENTORY_PRODUCTS_ADD_MULTIPLE:
    appBaseUrl + "/inventory/products/add/multiple",
  INVENTORY_PRODUCTS_ADD_COMPOSITE:
    appBaseUrl + "/inventory/products/add/composite",
  INVENTORY_PRODUCT_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/products/${id}/edit`;
  },
  INVENTORY_STORE_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/stores/${id}/edit`;
  },
  INVENTORY_SERVICE_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/services/${id}/edit`;
  },
  INVENTORY_PRODUCTS_EDIT_COMPOSITE: ({ id }) => {
    return appBaseUrl + `/composite-products/${id}/edit`;
  },
  INVENTORY_PRODUCT_BULK_TRANSFER_HISTORY:
    appBaseUrl + "/inventory/stock-transfers",
  INVENTORY_PRODUCT_BULK_TRANSFER:
    appBaseUrl + "/inventory/stock-transfers/create",
  INVENTORY_STOCK_TRANSFER_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/stock-transfers/${id}`;
  },
  INVENTORY_STOCK_TRANSFER_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/stock-transfers/${id}/edit`;
  },
  INVENTORY_PRODUCTS_BULK_RESTOCK:
    appBaseUrl + "/inventory/products/bulk-restock",
  INVENTORY_PRODUCTS_BULK_RESTOCK_UPDATE: ({ restock_id }) => {
    return appBaseUrl + `/inventory/products/bulk-restock/${restock_id}`;
  },
  INVENTORY_PRODUCT_STOCKHISTORY: ({ id }) => {
    return appBaseUrl + `/inventory/products/${id}/stock-history`;
  },
  INVENTORY_CATEGORIES: appBaseUrl + "/inventory/categories",
  INVENTORY_SALES_TRANSACTIONS: appBaseUrl + "/inventory/sales-transactions",
  INVENTORY_STOCK_HISTORY: appBaseUrl + "/inventory/stock-history",
  INVENTORY_SUPPLIERS: appBaseUrl + "/inventory/suppliers",
  INVENTORY_SUPPLIERS_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/suppliers/${id}`;
  },
  INVENTORY_SUPPLIERS_DETAILS_EDIT:
    appBaseUrl + "/inventory/suppliers/:id/edit",
  INVENTORY_RECONCILIATIONS: ({ store_id, isSellMode = false } = {}) => {
    return isSellMode
      ? `/sell-mode/${store_id}/reconciliations`
      : appBaseUrl + "/inventory/reconciliations";
  },
  INVENTORY_RECONCILIATIONS_EDIT: ({ store_id, id, isSellMode = false }) => {
    return isSellMode
      ? `/sell-mode/${store_id}/reconciliations/${id}`
      : appBaseUrl + `/inventory/reconciliations/${id}/edit`;
  },
  INVENTORY_RECONCILIATIONS_REVIEW: ({ store_id, id, isSellMode = false }) => {
    return isSellMode
      ? `/sell-mode/${store_id}/reconciliations/${id}/review`
      : appBaseUrl + `/inventory/reconciliations/${id}/review`;
  },
  INVENTORY_PRINTER: appBaseUrl + "/inventory/printer",
  INVENTORY_PRINTER_CONFIGURATION:
    appBaseUrl + "/inventory/printer/configuration",
  INVENTORY_TABLES: appBaseUrl + "/inventory/tables",
  INVENTORY_TABLES_DETAILS: appBaseUrl + "/inventory/tables/:id",
  INVENTORY_STORES: appBaseUrl + "/inventory/stores",
  INVENTORY_STORES_CREATE: appBaseUrl + "/inventory/stores/create",
  INVENTORY_STORE_DETIALS: appBaseUrl + "/inventory/stores/:id",
  INVENTORY_CREDITLOG: appBaseUrl + "/inventory/debtors",
  INVENTORY_CREDITLOG_DETAILS: appBaseUrl + "/inventory/debtors/:customerId",
  INVENTORY_MENU: appBaseUrl + "/inventory/storefront",
  INVENTORY_PRODUCTS_BATCH: appBaseUrl + "/inventory/products-batch",
  INVENTORY_RESTOCK_LOGS: appBaseUrl + "/inventory/restock-logs",
  INVENTORY_RESTOCK_DRAFTS: appBaseUrl + "/inventory/restock-drafts",
  ACCOUNTING_VAT_LEDGER: appBaseUrl + "/accountings/vat-ledger",
  INVENTORY_PRODUCTS_BATCH_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/products-batch/${id}`;
  },
  INVENTORY_MENU_DETAILS: ({ menuId }) => {
    return appBaseUrl + `/inventory/storefront/${menuId}/edit`;
  },
  INVENTORY_MENU_DETAILS_CUSTOMIZATION: ({ menuId }) => {
    return appBaseUrl + `/inventory/storefront/${menuId}/edit/customization`;
  },
  INVENTORY_MENU_DETAILS_CUSTOMIZATION_CHECKOUT: ({ menuId }) => {
    return (
      appBaseUrl + `/inventory/storefront/${menuId}/edit/customization/checkout`
    );
  },
  INVENTORY_MENU_DETAILS_CUSTOMIZATION_PAYMENT: ({ menuId }) => {
    return (
      appBaseUrl + `/inventory/storefront/${menuId}/edit/customization/payment`
    );
  },
  INVENTORY_MENU_DETAILS_CUSTOMIZATION_TEMPLATES: ({ menuId }) => {
    return (
      appBaseUrl +
      `/inventory/storefront/${menuId}/edit/customization/templates`
    );
  },
  INVENTORY_MENU_DETAILS_CUSTOMIZATION_BRANDING: ({ menuId }) => {
    return (
      appBaseUrl + `/inventory/storefront/${menuId}/edit/customization/branding`
    );
  },
  INVENTORY_MENU_DETAILS_CUSTOMIZATION_SORT_CATEGORIES: ({ menuId }) => {
    return (
      appBaseUrl +
      `/inventory/storefront/${menuId}/edit/customization/sort-categories`
    );
  },
  INVENTORY_MENU_CREATE: appBaseUrl + "/inventory/storefront/create",
  INVENTORY_MENU_CREATE_EDIT: ({ menuId }) => {
    return appBaseUrl + `/inventory/storefront/${menuId}/edit`;
  },
  INVENTORY_MENU_CREATE_CUSTOMIZATION: ({ menuId }) => {
    return appBaseUrl + `/inventory/storefront/${menuId}/customization`;
  },
  INVENTORY_MENU_CREATE_CUSTOMIZATION_CHECKOUT: ({ menuId }) => {
    return (
      appBaseUrl + `/inventory/storefront/${menuId}/customization/checkout`
    );
  },
  INVENTORY_MENU_CREATE_CUSTOMIZATION_PAYMENT: ({ menuId }) => {
    return appBaseUrl + `/inventory/storefront/${menuId}/customization/payment`;
  },
  INVENTORY_MENU_CREATE_CUSTOMIZATION_TEMPLATES: ({ menuId }) => {
    return (
      appBaseUrl + `/inventory/storefront/${menuId}/customization/templates`
    );
  },
  INVENTORY_MENU_CREATE_CUSTOMIZATION_BRANDING: ({ menuId }) => {
    return (
      appBaseUrl + `/inventory/storefront/${menuId}/customization/branding`
    );
  },
  INVENTORY_MENU_CREATE_CUSTOMIZATION_SORT_CATEGORIES: ({ menuId }) => {
    return (
      appBaseUrl +
      `/inventory/storefront/${menuId}/customization/sort-categories`
    );
  },
  INVENTORY_MENU_CREATE_SHIPPING: ({ menuId }) => {
    return appBaseUrl + `/inventory/storefront/${menuId}/shipping`;
  },
  INVENTORY_MENU_PAYMENT: appBaseUrl + "/inventory/storefront/payment-method",
  INVENTORY_SHIPPINGS: appBaseUrl + "/inventory/storefront/shippings",
  INVENTORY_RIDERS: appBaseUrl + "/inventory/storefront/riders",
  INVENTORY_MENU_PAYMENT_DETAILS: ({ paymentId }) => {
    return appBaseUrl + `/inventory/storefront/payment-method/${paymentId}`;
  },
  INVENTORY_STOREFRONT_ORDER_STATUS: ({ id, menuId }) => {
    return `/storefront/${menuId}/${id}/status`;
  },
  INVENTORY_STOREFRONT_RIDER_ORDERS: ({ id }) => {
    return `/storefront/rider-orders/${id}/`;
  },
  INVENTORY_STOREFRONT_ORDER_DETAILS: ({ id }) => {
    return `/storefront/order-details/${id}`;
  },
  INVENTORY_INVOICE_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/invoices/${id}`;
  },
  CREDIT_LOG_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/debtors/${id}`;
  },
  INVENTORY_PRODUCT_ITEM_TRACKING: appBaseUrl + "/inventory/track-item",

  INVENTORY_STORE_WALLET_LIST: appBaseUrl + "/inventory/store-wallets",
  INVENTORY_STORE_WALLET_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/store-wallets/${id}`;
  },
  INVENTORY_STORE_WALLET_TRANSACTION_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/store-wallets/transaction/${id}`;
  },
  // purchase order
  INVENTORY_PURCHASE_ORDER: appBaseUrl + "/inventory/purchase-order",
  INVENTORY_PURCHASE_ORDER_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/purchase-order/${id}`;
  },
  INVENTORY_PURCHASE_ORDER_CREATE:
    appBaseUrl + "/inventory/purchase-order/create",
  INVENTORY_PURCHASE_ORDER_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/purchase-order/${id}/edit`;
  },
  // PO categories
  INVENTORY_PO_CATEGORIES: appBaseUrl + "/inventory/po-categories",
  // Good Recieved
  INVENTORY_GOODS_RECEIVED: appBaseUrl + "/inventory/goods-received",
  INVENTORY_GOODS_RECEIVED_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/goods-received/${id}`;
  },
  INVENTORY_GOODS_RECEIVED_CREATE:
    appBaseUrl + "/inventory/goods-received/create",
  INVENTORY_GOODS_RECEIVED_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/goods-received/${id}/edit`;
  },
  // Bills
  INVENTORY_BILLS: appBaseUrl + "/inventory/bills",
  INVENTORY_BILLS_DETAILS: ({ id }) => {
    return appBaseUrl + `/inventory/bills/${id}`;
  },
  INVENTORY_BILLS_CREATE: appBaseUrl + "/inventory/bills/create",
  INVENTORY_BILLS_EDIT: ({ id }) => {
    return appBaseUrl + `/inventory/bills/${id}/edit`;
  },

  STORES: appBaseUrl + "/stores",
  // Start sell mode -------------------------------------
  CASHIER_STORES: "/sell-mode",
  SELL_MODE: ({ store_id }) => {
    return `/sell-mode/${store_id}`;
  },
  SELL_MODE_CHECKOUT: ({ store_id }) => {
    return `/sell-mode/${store_id}/checkout`;
  },
  SELL_MODE_BILLS: ({ store_id }) => {
    return `/sell-mode/${store_id}/bills`;
  },
  SELL_MODE_SALES: ({ store_id }) => {
    return `/sell-mode/${store_id}/sales`;
  },
  SELL_MODE_CUSTOMERS: ({ store_id }) => {
    return `/sell-mode/${store_id}/customers`;
  },
  SELL_MODE_SECTION_ORDERS: ({ store_id }) => {
    return `/sell-mode/${store_id}/section-orders`;
  },
  SELL_MODE_ENDOFDAY: ({ store_id }) => {
    return `/sell-mode/${store_id}/end-of-day`;
  },
  SELL_MODE_RETURNS: ({ store_id }) => {
    return `/sell-mode/${store_id}/returns`;
  },
  SELL_MODE_PENDING_CHECKOUT: ({ store_id }) => {
    return `/sell-mode/${store_id}/pending-checkout`;
  },
  SELL_MODE_ORDER_EXTRA: ({ store_id, order_id }) => {
    return `/sell-mode/${store_id}/${order_id}`;
  },
  SELL_MODE_BILL_CHECKOUT: ({ store_id, order_id }) => {
    return `/sell-mode/${store_id}/${order_id}/bill-continuation`;
  },
  SELL_MODE_TERMINAL_CONFIG: ({ store_id }) => {
    return `/sell-mode/${store_id}/assign-terminal`;
  },
  SELL_MODE_SERVICE_DETAILS: ({ store_id, service_id }) => {
    return `/sell-mode/${store_id}/services/${service_id}`;
  },
  // End Sell mode --------------------------------------------
  SECTIONS: appBaseUrl + "/sections",
  SECTION_MODE: ({ section_id }) => {
    return `/section-mode/${section_id}`;
  },
  SECTION_CUSTOMER_MODE: ({ store_id }) => {
    return `/sections-customesr/${store_id}`;
  },
  MANAGE_SECTIONS: appBaseUrl + "/manage-sections",

  EXPENSES_ANALYTICS: appBaseUrl + "/expenses/analytics",
  EXPENSES_BULK_CREATE: appBaseUrl + "/expenses/create",
  EXPENSES_DETAILS: ({ id, store_id, isSellMode = false }) => {
    return isSellMode
      ? `/sell-mode/${store_id}/expenses/${id}`
      : appBaseUrl + `/expenses/${id}`;
  },
  EXPENSES_LIST: ({ store_id, isSellMode = false } = {}) => {
    return isSellMode
      ? `/sell-mode/${store_id}/expenses`
      : appBaseUrl + "/expenses";
  },
  EXPENSES_CATEGORIES: appBaseUrl + "/expenses/categories",
  EXPENSES_DEPARTMENTS: appBaseUrl + "/expenses/departments",

  ACCOUNTING_OVERVIEW: appBaseUrl + "/accounting",
  ACCOUNTING_PROFITANDLOSS: appBaseUrl + "/accounting/profit-and-loss",
  ACCOUNTING_DETAILS: ({ id }) => {
    return appBaseUrl + `/accounting/${id}`;
  },

  LOYALTY_MANAGE: appBaseUrl + "/marketing/loyalty/manage",
  PROCUREMENT_WAYBILLS: appBaseUrl + "/procurement/waybills",
  PROCUREMENT_GENERATE_WAYBILL: appBaseUrl + "/procurement/generate-waybill",
  PROCUREMENT_VIEW_WAYBILL: ({ id }) => {
    return appBaseUrl + `/procurement/view-waybill/${id}`;
  },
  LOYALTY_MANAGE_CAMPAIGN: appBaseUrl + "/marketing/loyalty/manage/campaigns",
  LOYALTY_CREATE_CAMPAIGN:
    appBaseUrl + "/marketing/loyalty/manage/campaigns/create",
  LOYALTY_EDIT_CAMPAIGN: ({ campaignId }) => {
    return (
      appBaseUrl + `/marketing/loyalty/manage/campaigns/edit/${campaignId}`
    );
  },
  LOYALTY_MANAGE_GIFTCARDS: appBaseUrl + "/marketing/loyalty/manage/giftcards",
  LOYALTY_CREATE_GIFTCARD:
    appBaseUrl + "/marketing/loyalty/manage/giftcards/create",
  LOYALTY_EDIT_GIFTCARD: ({ giftcardId }) => {
    return (
      appBaseUrl + `/marketing/loyalty/manage/giftcards/edit/${giftcardId}`
    );
  },
  LOYALTY_CUSTOMERS: appBaseUrl + "/marketing/loyalty/customers/all",
  LOYALTY_CUSTOMERS_DETAILS: ({ id }) => {
    return appBaseUrl + `/marketing/loyalty/customers/${id}`;
  },
  LOYALTY_CUSTOMERS_HISTORY:
    appBaseUrl + "/marketing/loyalty/customers/history",
  LOYALTY_NOTIFICATION: appBaseUrl + "/marketing/loyalty/account-status",

  // Start of performance ----------------------
  PERFORMANCE_GOALS: appBaseUrl + "/performance/goals",
  PERFORMANCE_GOALS_DETAILS: ({ id }) => {
    return appBaseUrl + `/performance/goals/${id}`;
  },
  // End of performance ----------------------

  // Start of Marketing----------------
  MARKETING_SMS_CAMPAIGNS_CUSTOM:
    appBaseUrl + "/marketing/sms-campaigns/custom",
  MARKETING_SMS_CAMPAIGNS_AUTOMATED:
    appBaseUrl + "/marketing/sms-campaigns/automated",
  MARKETING_SMS_CAMPAIGNS_CREATE:
    appBaseUrl + "/marketing/sms-campaigns/create",
  MARKETING_SMS_CAMPAIGNS_CONTEXT: ({ id }) => {
    return appBaseUrl + `/marketing/sms-campaigns/${id}/context`;
  },
  MARKETING_SMS_CAMPAIGNS_AUDIENCE: ({ id }) => {
    return appBaseUrl + `/marketing/sms-campaigns/${id}/audience`;
  },
  MARKETING_SMS_CAMPAIGNS_CONTENT: ({ id }) => {
    return appBaseUrl + `/marketing/sms-campaigns/${id}/content`;
  },
  MARKETING_SMS_CAMPAIGNS_REVIEW: ({ id }) => {
    return appBaseUrl + `/marketing/sms-campaigns/${id}/review`;
  },
  MARKETING_SMS_CAMPAIGNS_SCHEDULE: ({ id }) => {
    return appBaseUrl + `/marketing/sms-campaigns/${id}/schedule`;
  },
  MARKETING_SMS_CAMPAIGNS_DETAILS: ({ id }) => {
    return appBaseUrl + `/marketing/sms-campaigns/${id}`;
  },
  // End of Marketing------------------

  DOCUMENTATION: appBaseUrl + "/documentation",

  CUSTOMERS: appBaseUrl + "/customers",
  CUSTOMER_CREATE: appBaseUrl + "/customers/create",
  CUSTOMER_DETAILS: ({ customerId }) => {
    return appBaseUrl + `/customers/${customerId}`;
  },
  CUSTOMER_EDIT: ({ customerId }) => {
    return appBaseUrl + `/customers/${customerId}/edit`;
  },
  KYB_VERIFICATION: appBaseUrl + "/kyb-verification",

  SETTINGS: appBaseUrl + "/settings",
  SETTINGS_USERS: appBaseUrl + "/settings/users",
  SETTINGS_SECURITY_PIN_QUESTION: appBaseUrl + "/settings/security/pin",
  SETTINGS_USERS_MANAGEROLES: appBaseUrl + "/settings/users/manage-roles",
  SETTINGS_USERS_MANAGEROLES_DETAILS: ({ id }) => {
    return appBaseUrl + `/settings/users/manage-roles/${id}`;
  },
  SETTINGS_USERS_MANAGEROLES_DEFAULT:
    appBaseUrl + "/settings/users/manage-roles/default",
  SETTINGS_USERS_MANAGEROLES_CUSTOM:
    appBaseUrl + "/settings/users/manage-roles/custom",
  SETTINGS_SETTLEMENTS: appBaseUrl + "/settings/settlements",
  SETTINGS_APIKEYS: appBaseUrl + "/settings/api-keys",
  SETTINGS_PROFILE: appBaseUrl + "/settings/profile",
  SETTINGS_BUSINESS_PROFILE: appBaseUrl + "/settings/business-profile",
  SETTINGS_SUBSCRIPTIONS: appBaseUrl + "/settings/subscriptions",
  SETTINGS_SUBSCRIPTIONS_PLANS: appBaseUrl + "/settings/subscriptions/plans",
  SETTINGS_ACTIVITY_LOGS: appBaseUrl + "/settings/activity-logs",
  SETTINGS_ACTIVITY_LOGS_DETAILS: ({ id }) => {
    return appBaseUrl + `/settings/activity-logs/${id}`;
  },
  SETTINGS_PLATFORM_CREDIT: appBaseUrl + "/settings/platform-credit",
  SETTINGS_PLATFORM_CREDIT_TOPUP:
    appBaseUrl + "/settings/platform-credit/top-up",

  AI_ASSISTANCE: appBaseUrl + "/ai-assistance",
  LUMI_AI_ASSISTANT: appBaseUrl + "/lumi-ai-assistant",
  LUMI_AI_ASSISTANT_CONVERSATION:
    appBaseUrl + "/lumi-ai-assistant/:conversationId",

  APP_SUBSCRIPTION_PLAN: appBaseUrl + "/subscription-plans",
  APP_RECEIPT_CUSTOMIZATION:
    appBaseUrl + "/inventory/printer/receipt-customization",

  CLIENT_LOGIN: "/client/login/:token",
  CLIENT_EXISTING_CONNECT: "/client/login/existing-account/:token",

  REQUEST_CAPITAL: appBaseUrl + "/request_capital",

  //market place
  APPS_MAIN: appBaseUrl + "/markets",
  APPS_DETAILS: ({ id }) => {
    return appBaseUrl + `/markets/${id}`;
  },

  //chowdeck
  APPS_CHOWDECK: appBaseUrl + "/chowdeck",
  APPS_CHOWDECK_SETUP: appBaseUrl + "/chowdeck/set-up",
  APPS_CHOWDECK_CONNECTIONS: appBaseUrl + "/chowdeck/connections",
  APPS_CHOWDECK_CONNECT_STORE: ({ connection_id }) => {
    return appBaseUrl + `/chowdeck/connect-store/${connection_id}`;
  },
  APPS_CHOWDECK_CONNECT_STORE_EDIT: ({ connection_id }) => {
    return appBaseUrl + `/chowdeck/connect-store/${connection_id}/edit`;
  },
  APPS_CHOWDECK_API_MANAGEMENT: appBaseUrl + "/chowdeck/api-management",

  // Squareup
  APPS_SQUAREUP: appBaseUrl + "/squareup/auth",
  APPS_SQUAREUP_AUTH_CALLBACK: appBaseUrl + "/squareup/auth-callback",
  APPS_SQUAREUP_CONNECTED_STORE: appBaseUrl + "/squareup/connections",
  APPS_SQUAREUP_CONNECT_STORE: appBaseUrl + "/squareup/connect-store",
  APPS_SQUAREUP_CONNECT_STORE_EDIT: ({ connection_id }) => {
    return appBaseUrl + `/squareup/connect-store/${connection_id}/edit`;
  },

  // interswitch
  APPS_INTEGRATION_BUSINESS_CONNECTION:
    appBaseUrl + "/integrations/business-connections",
  APPS_INTEGRATION_TERMINALS: appBaseUrl + "/integrations/terminals",
  APPS_INTEGRATION_TERMINALS_CONNECT:
    appBaseUrl + "/integrations/terminals/connect",
  APPS_INTEGRATION_TERMINALS_CONNECT_EDIT: ({ id }) => {
    return appBaseUrl + `/integrations/terminals/connect/${id}`;
  },

  // Returns
  INVENTORY_RETURNS: appBaseUrl + "/inventory/returns",
  INVENTORY_RETURNS_REVIEW: ({ id }) =>
    appBaseUrl + "/inventory/returns/" + id + "/review",

  // Stock Removals
  INVENTORY_STOCK_REMOVALS: appBaseUrl + "/inventory/stock-removals",
  INVENTORY_STOCK_REMOVALS_REVIEW: ({ id }) =>
    appBaseUrl + "/inventory/stock-removals/" + id + "/review",

  TEST_MOBILE_COM: appBaseUrl + "/test-mobile-com",
};
